<!-- ConsultantLoginJWT.vue -->
<template>
  <div>
    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      label-placeholder="Email"
      v-model="email"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("email") }}</span>

    <vs-input
      data-vv-validate-on="blur"
      v-validate="'required'"
      type="password"
      name="password"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather"
      label-placeholder="Password"
      v-model="password"
      class="w-full mt-6"
      v-on:keyup.enter="onEnter"
    />
    <span class="text-danger text-sm">{{ errors.first("password") }}</span>

    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
      <p class="small cursor-pointer" @click="ForgetPasswordPrompt = true">Forgot Password?</p>
    </div>
    
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button :disabled="!validateForm" :color="validateForm ? 'success' : 'primary'" @click="loginConsultant" class="w-full">
        Login as Consultant
      </vs-button>
    </div>

    <!-- Forget Password Prompt -->
    <vs-prompt
      color="primary"
      title="Recover Password"
      accept-text="Submit"
      cancel-text="Cancel"
      @cancel="forget_password_email=''"
      @accept="forget_password"
      @close="forget_password_email='', ForgetPasswordPrompt = false"
      :active.sync="ForgetPasswordPrompt"
    >
      <p class="mb-4">Enter your email to receive a new system-generated password.</p>
      <vs-input
        size="large"
        v-validate="'required|email'"
        name="email"
        v-model="forget_password_email"
        class="w-full mb-6"
        icon-pack="feather"
        icon="icon-mail"
        icon-no-border
      />
      <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      forget_password_email: "",
      checkbox_remember_me: false,
      ForgetPasswordPrompt: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== "" && this.password !== "";
    },
  },
  methods: {
    onEnter() {
      this.loginConsultant();
    },
    loginConsultant() {
      this.$vs.loading();

      const payload = {
        email: this.email,
        password: this.password,
        remember_me: this.checkbox_remember_me
      };

      // FIXED DISPATCH NAME HERE
      this.$store
        .dispatch("userAuth/loginConsultant", payload) 
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({ title: "Success", text: "Logged in successfully", color: "success" });
          
          // Route them to their specific separated dashboard
          this.$router.push({ name: 'consultant-profile' }); 
        })
        .catch(error => {
          this.$vs.loading.close();
          
          const errorMessage = (error.response && error.response.data && error.response.data.message) 
            ? error.response.data.message 
            : error.message || "Invalid credentials";

          this.$vs.notify({
            title: "Login Failed",
            text: errorMessage,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    forget_password() {
       const payload = { email: this.forget_password_email };
       
       // NOTE: Create a new action for consultant password reset
       this.$store.dispatch("consultantAuth/resetPassword", payload)
        .then(() => {
          this.$vs.notify({
            title: "Email Sent",
            text: "A new password has been sent to your email.",
            color: "primary"
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Error",
            text: "Could not find that email.",
            color: "danger"
          });
        });
    }
  }
};
</script>